import axiosInstance from './axiosInstance';

const fetchCards = async ({token: token}) => {
  try {
    const response = await axiosInstance.post(
      '/cards', 
      {
      },
      {
        headers: {
          Authorization: token,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw new Error('Error posting data: ' + error.message);
  }
};

export {fetchCards};